import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFireModule } from '@angular/fire/compat';
import { AngularFireAuthModule } from '@angular/fire/compat/auth';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFireDatabaseModule } from '@angular/fire/compat/database';
import { AngularFireMessagingModule } from '@angular/fire/compat/messaging';
import { AngularFirePerformanceModule } from '@angular/fire/compat/performance';
import { AngularFireRemoteConfigModule } from '@angular/fire/compat/remote-config';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi
} from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { environment } from 'src/environments/environment';
import { AuthService } from './services/auth/auth.service';
import { FirebaseService } from './services/firebase/firebase.service';
import { BcryptService } from './services/bcrypt/bcrypt.service';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { effects } from './store';
import { userReducer } from './store/reducers/user.reducer';
import { doubtsReducer } from './store/reducers/doubts.reducer';
import { GoogleAuthService } from './services/google/google-auth.service';
import { MAT_DATE_LOCALE, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { eventsReducer } from './store/reducers/calendar.reducer';
import { paymentsReducer } from './store/reducers/payments.reducer';
import { reviewsReducer } from './store/reducers/reviews.reducer';
import { subscriptionsReducer } from './store/reducers/subscriptions.reducer';
import { clientsControlReducer } from './store/reducers/clients-control.reducer';
import { resourcesReducer } from './store/reducers/resources.reducers';
import { AuthInterceptorService } from './interceptors/auth-interceptor.service';

export function HttpLoaderFactory(httpClient: HttpClient) {
  return new TranslateHttpLoader(httpClient, '../assets/i18n/', '.json');
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireAuthModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    AngularFireDatabaseModule,
    AngularFireMessagingModule,
    AngularFirePerformanceModule,
    AngularFireRemoteConfigModule,
    StoreModule.forRoot({
      userData: userReducer,
      doubtsData: doubtsReducer,
      eventsData: eventsReducer,
      paymentsData: paymentsReducer,
      reviewsData: reviewsReducer,
      subscriptionsData: subscriptionsReducer,
      clientsControlData: clientsControlReducer,
      resourcesData: resourcesReducer
    }),
    StoreDevtoolsModule.instrument({}),
    EffectsModule.forRoot(effects),
    TranslateModule.forRoot({
      defaultLanguage: window.navigator.language,
      useDefaultLang: true,
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    ToolbarComponent,
    SidenavComponent,
    MatNativeDateModule,
    MatDatepickerModule
  ],
  providers: [
    AuthService,
    FirebaseService,
    BcryptService,
    GoogleAuthService,
    provideHttpClient(withInterceptorsFromDi()),
    { provide: MAT_DATE_LOCALE, useValue: window.navigator.language },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
